import {
  useTheme,
  Button,
  SunOutlined,
  MoonOutlined,
  MenuOutlined,
} from "@mimber/ui-web"
import { ProfileDropdown } from "@/components/dropdowns"
import { useIsMobileViewport } from "@mimber/ui-web"
import type { AppHeaderProps } from "./AppHeader.types"

export const AppHeader: React.FunctionComponent<AppHeaderProps> = ({
  showThemeToggle = true,
  showUserProfile = true,
  onMenuClick,
  children,
}) => {
  const { isDark, toggleTheme } = useTheme()
  const isMobile = useIsMobileViewport()

  return (
    <>
      {/* Hamburger menu trigger (mobile only, and only when a handler is wired up) */}
      {isMobile && onMenuClick && (
        <Button
          type="text"
          icon={<MenuOutlined />}
          onClick={onMenuClick}
          size="large"
          className="ml-2 flex items-center justify-center text-base"
          aria-label="Open navigation menu"
        />
      )}

      {/* Logo/Branding */}
      <div className="ml-6 flex items-center gap-3">
        <img src="/logo.svg" alt="Mimber Logo" className="h-8 w-auto" />
        <span className="text-xl font-semibold tracking-[-0.5px]">Mimber</span>
      </div>

      {/* Right side content */}
      <div className="ml-auto mr-6 flex items-center gap-3">
        {/* Custom children */}
        {children}

        {/* Dark mode toggle */}
        {showThemeToggle && (
          <Button
            type="text"
            icon={isDark ? <SunOutlined /> : <MoonOutlined />}
            onClick={toggleTheme}
            size="large"
            className="flex items-center justify-center text-base"
            title={isDark ? "Switch to light mode" : "Switch to dark mode"}
          />
        )}

        {/* User profile icon */}
        {showUserProfile && (
          <ProfileDropdown className="flex cursor-pointer items-center justify-center" />
        )}
      </div>
    </>
  )
}
